<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent != null && localService.languageContent.serial_num != undefined">
  <app-popup-header title="{{localService.languageContent.serial_num.header}}"></app-popup-header>
  <div class="modal-body" *ngIf="wrapper" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}">
    <div class="row">
      <div class="col-12">
        <ngx-select *ngIf="statuses" [(ngModel)]="wrapper.v3" [optionValueField]="'key'" [optionTextField]="'value'"
          [items]="statuses" [noAutoComplete]="true"
          placeholder="{{localService.languageContent.serial_num.select_status}}"
          title="{{localService.languageContent.serial_num.select_status}}" (open)="showHideDummyHeight(true)"
          (close)="showHideDummyHeight(false)">
        </ngx-select>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <input autocomplete="off" type="text" id="{{elementIds.serial_val}}" [ngClass]="wrapper.v2 != '' ? 'en' : ''"
          [(ngModel)]="wrapper.v2" placeholder="{{localService.languageContent.serial_num.serial_num_val}}"
          title="{{localService.languageContent.serial_num.serial_num_val}}" (input)="onSerialEnter($event)" />
      </div>
    </div>
    <div class="row">
      <div class="col-6">
        <label style="margin-left:10px;font-weight:normal;">
          <input type="checkbox" [(ngModel)]="isExpiryAllowed">
          <span style="color:darkslategrey">&nbsp;{{localService.languageContent.serial_num.is_exp_allow}}</span>
        </label>
      </div>
      <div class="col-6">
        <app-date-picker [isDisabled]="!isExpiryAllowed" [selectedDate]="selectedDate"
          (selectedDateChange)="selectedDate = $event" (isOpenChange)="showHideDummyHeight($event)"></app-date-picker>
      </div>
    </div>
    <div *ngIf="isShowDummyHeight" [ngStyle]="{'height' : localService.getHeightOfOpenedControls('6') + 'px'}">
      &nbsp;
    </div>
  </div>
  <div class="modal-footer modal_footer_message" *ngIf="message != ''">
    <span [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onPopupSave()">{{ id == '' ?
      localService.languageContent.common.create : localService.languageContent.common.save}}</button>
  </div>
</div>